import { ButtonPrimaryTextOnly } from '@creditas-ui/react'
import React, { useContext } from 'react'
import { ModalContext } from 'shared/ui'
import { Hero, SpacingSection, Title } from './Home.styles'

const Header = () => {
  const { handleModalOpen } = useContext(ModalContext)

  return (
    <SpacingSection>
      <Hero>
        <Title data-testid="leads-list-title" variant="h4">
          Suas propostas
        </Title>
        <ButtonPrimaryTextOnly
          data-testid="btn-new-proposal"
          variant="primary"
          onClick={() => handleModalOpen()}
        >
          Nova proposta
        </ButtonPrimaryTextOnly>
      </Hero>
    </SpacingSection>
  )
}

export { Header }
